(function () {
  'use strict';

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    var key = root.dataset.packageKey;
    var single = root.dataset.accordionBehavior === 'single';
    var panels = Array.from(root.querySelectorAll('[data-accordion]'));
    var busy = false;

    function activate(selection) {
      root.hidden = !selection || selection.key !== key;
    }

    window.Naxarly?.ServicePage?.subscribe(activate);
    activate(window.Naxarly?.ServicePage?.getSelection?.());

    panels.forEach(function (panel) {
      panel.addEventListener('toggle', function () {
        if (!single || busy || !panel.open) return;
        busy = true;
        panels.forEach(function (other) { if (other !== panel) other.open = false; });
        busy = false;
      });
    });

    root.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var holder = gallery.querySelector('[data-gallery-tabs]');
      var tabPanels = Array.from(gallery.querySelectorAll('[data-gallery-tab-panel]'));

      function select(index) {
        Array.from(holder.children).forEach(function (button, buttonIndex) {
          var selected = buttonIndex === index;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-selected', String(selected));
          button.tabIndex = selected ? 0 : -1;
        });
        tabPanels.forEach(function (panel, panelIndex) { panel.hidden = panelIndex !== index; });
      }

      tabPanels.forEach(function (panel, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('role', 'tab');
        button.innerHTML = (panel.dataset.tabIcon ? panel.dataset.tabIcon + ' ' : '') + '<span>' + panel.dataset.tabTitle + '</span>';
        button.addEventListener('click', function () { select(index); });
        holder.append(button);
      });
      if (tabPanels.length) select(0);
    });

    var dialog = root.querySelector('[data-lightbox-dialog]');
    var stage = root.querySelector('[data-lightbox-content]');
    var counter = root.querySelector('[data-lightbox-counter]');
    var sequence = [];
    var currentIndex = 0;
    var lastTrigger = null;
    var pointerStart = 0;
    var lastTap = 0;

    function pauseVideos() { dialog?.querySelectorAll('video').forEach(function (video) { video.pause(); }); }
    function renderLightbox() {
      pauseVideos();
      stage.replaceChildren();
      var trigger = sequence[currentIndex];
      if (!trigger) return;
      if (trigger.dataset.lightbox === 'image') {
        var image = trigger.querySelector('img')?.cloneNode();
        if (image) {
          image.addEventListener('click', function () {
            var now = Date.now();
            if (now - lastTap < 320) image.classList.toggle('is-zoomed');
            lastTap = now;
          });
          stage.append(image);
        }
      } else {
        var template = trigger.querySelector('template');
        if (template) stage.append(template.content.cloneNode(true));
      }
      counter.textContent = (currentIndex + 1) + ' / ' + sequence.length;
    }
    function move(direction) { currentIndex = (currentIndex + direction + sequence.length) % sequence.length; renderLightbox(); }
    function closeLightbox() {
      pauseVideos();
      if (dialog.open) dialog.close();
      stage.replaceChildren();
      document.documentElement.style.overflow = '';
      lastTrigger?.focus();
    }

    root.querySelectorAll('[data-lightbox]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        sequence = Array.from(trigger.closest('[data-gallery-tab-panel]').querySelectorAll('[data-lightbox]'));
        currentIndex = sequence.indexOf(trigger);
        lastTrigger = trigger;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        renderLightbox();
      });
    });
    root.querySelector('[data-lightbox-prev]')?.addEventListener('click', function () { move(-1); });
    root.querySelector('[data-lightbox-next]')?.addEventListener('click', function () { move(1); });
    root.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
    dialog?.addEventListener('cancel', function (event) { event.preventDefault(); closeLightbox(); });
    dialog?.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') move(-1);
      if (event.key === 'ArrowRight') move(1);
    });
    dialog?.addEventListener('pointerdown', function (event) { pointerStart = event.clientX; });
    dialog?.addEventListener('pointerup', function (event) {
      if (Math.abs(event.clientX - pointerStart) > 48) move(event.clientX > pointerStart ? -1 : 1);
    });
  }

  function handleCustomization(event) {
    var detail = event.detail || {};
    var root = Array.from(document.querySelectorAll('[data-nsc-modular]')).find(function (item) {
      return item.dataset.packageKey === detail.packageKey;
    });
    if (!root) return;

    var target = detail.target ? root.querySelector('[data-addon-key="' + CSS.escape(detail.target) + '"]') : null;
    var panel = target?.closest('[data-accordion]');
    if (!panel && detail.target) panel = root.querySelector('[data-content-key="' + CSS.escape(detail.target) + '"]');
    if (!panel) panel = root.querySelector('[data-layout="add_on_cards"]');
    if (!panel) return;

    panel.open = true;
    window.requestAnimationFrame(function () {
      (target || panel).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      if (target) {
        target.classList.add('is-highlighted');
        window.setTimeout(function () { target.classList.remove('is-highlighted'); }, 1600);
      }
    });
  }

  function boot() { document.querySelectorAll('[data-nsc-modular]').forEach(init); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('naxarly:customize', handleCustomization);
})();
